import { cancelProgress } from 'lib/popsss/progress/actions';
import events from 'lib/events';

export const RECIPIENTS_MODAL_OPEN = 'RECIPIENTS_MODAL_OPEN';
export const RECIPIENTS_MODAL_CANCEL = 'RECIPIENTS_MODAL_CANCEL';

export const RECIPIENT_TICK = 'RECIPIENT_TICK';
export const RECIPIENT_UNTICK = 'RECIPIENT_UNTICK';
export const RECIPIENTS_UNTICK_ALL = 'RECIPIENTS_UNTICK_ALL';

export const RECIPIENTS_STATE_FETCH = 'RECIPIENTS_STATE_FETCH';
export const RECIPIENTS_STATE_SUCCESS = 'RECIPIENTS_STATE_SUCCESS';
export const RECIPIENTS_STATE_FAIL = 'RECIPIENTS_STATE_FAIL';

export const RECIPIENTS_SEND_SUBMIT = 'RECIPIENTS_SEND_SUBMIT';
export const RECIPIENTS_SEND_DONE = 'RECIPIENTS_SEND_DONE';
export const RECIPIENTS_SEND_SUCCESS = 'RECIPIENTS_SEND_SUCCESS';
export const RECIPIENT_SEND_SUCCESS = 'RECIPIENT_SEND_SUCCESS';
export const RECIPIENTS_SEND_FAIL = 'RECIPIENTS_SEND_FAIL';

export const CONTRACT_SECTIONS_FETCH = 'CONTRACT_SECTIONS_FETCH';
export const CONTRACT_SECTIONS_SUCCESS = 'CONTRACT_SECTIONS_SUCCESS';
export const CONTRACT_SECTIONS_FAIL = 'CONTRACT_SECTIONS_FAIL';

export const openContractsModal = () => ({ type: RECIPIENTS_MODAL_OPEN });
export const closeContractsModal = () => ({ type: RECIPIENTS_MODAL_CANCEL });

export function tick(id) {
  return { type: RECIPIENT_TICK, ids: [id] };
}

export function untick(id) {
  return { type: RECIPIENT_UNTICK, ids: [id] };
}

export function tickAll() {
  return (dispatch, getState) => {
    let recipients = getState().contracts.recipients;
    recipients = Object.keys(recipients).filter(
      (key) => recipients[key].can_send,
    );
    dispatch({ type: RECIPIENT_TICK, ids: recipients });
  };
}

export function untickAll() {
  return { type: RECIPIENTS_UNTICK_ALL };
}

export function getVisibleTicks(state) {
  return state.contracts.recipientsTicked;
}

function getRecipientsState(endpoint, params) {
  return (dispatch) => {
    dispatch({ type: RECIPIENTS_STATE_FETCH });

    popsss
      .postJSON(`/api/project/contracts/v1/${endpoint}`, params)
      .done((result) => {
        if (result.results) {
          dispatch({
            type: RECIPIENTS_STATE_SUCCESS,
            recipients: result.results,
          });

          // Tick the ones that can be previewed
          const recipients = result.results;
          const ids = Object.keys(recipients).filter(
            (profile_id) => recipients[profile_id].can_send,
          );
          dispatch({ type: RECIPIENT_TICK, ids });
        } else if (result.error) {
          dispatch({ type: RECIPIENTS_STATE_FAIL, error: result.error });
          dispatch(closeContractsModal());
        } else {
          dispatch({ type: RECIPIENTS_STATE_FAIL, error: null });
          dispatch(closeContractsModal());
        }
      })
      .fail(() => {
        dispatch({ type: RECIPIENTS_STATE_FAIL, error: null });
      });
  };
}

export function getEntriesState(list_id, entry_ids) {
  return getRecipientsState('entries_state', {
    list_id,
    entry_ids: JSON.stringify(entry_ids),
  });
}

export function getListContractSectionsState(list_id) {
  return getContractSections({
    list_id,
  });
}

export function getContractSections(params) {
  return (dispatch) => {
    dispatch({ type: CONTRACT_SECTIONS_FETCH });

    popsss
      .getJSON('/api/project/contracts/v1/contract_sections', params)
      .done((result) => {
        if (result.results) {
          dispatch({
            type: CONTRACT_SECTIONS_SUCCESS,
            contractSections: result.results,
          });
        }
      })
      .fail(() => {
        dispatch({ type: CONTRACT_SECTIONS_FAIL, error: undefined });
      });
  };
}

export function cancelSendContracts() {
  return cancelProgress();
}

export function sendContracts(list_id, contractSection) {
  return (dispatch, getState) => {
    const tickedRecipients = getVisibleTicks(getState());
    // CBA when no recipients ticked
    if (tickedRecipients.length === 0) {
      return;
    }

    // Bind to contract events, to update the modal async
    events.addUserBind('contracts', (event) => {
      const result = event.result;
      const recipient_id = result.recipient_id;
      const recipients = {};
      recipients[recipient_id] = result;
      dispatch({ type: RECIPIENT_SEND_SUCCESS, recipients });
      dispatch(untick(`${recipient_id}`));
    });

    dispatch({ type: RECIPIENTS_SEND_SUBMIT, ticked: tickedRecipients });

    popsss
      .postJSON('/api/project/contracts/v1/send', {
        list_id,
        profile_ids: JSON.stringify(tickedRecipients.map(Number)),
        contract_section: contractSection,
      })
      .done((result) => {
        if (result.results) {
          dispatch({
            type: RECIPIENTS_SEND_SUCCESS,
            recipients: result.results,
          });
        } else if (result.error) {
          dispatch({ type: RECIPIENTS_SEND_FAIL, error: result.error });
          popsss.alertError(`Error while sending contracts: ${result.error}`);
        } else {
          dispatch({ type: RECIPIENTS_SEND_FAIL, error: null });
        }
      })
      .fail(() => {
        dispatch({ type: RECIPIENTS_SEND_FAIL, error: null });
      });
  };
}
